export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7925.4f65ca42.jpg";